import { createContext } from 'react';

// When true, every descendant `useNectarImpression` is suppressed. Set by gates
// that render real content blurred and `inert` behind an overlay (e.g.
// GatedFeedOverlay): the posts are in the DOM and viewport, so the impression
// observer would otherwise fire for cards the viewer can't actually read.
export const ImpressionSuppressionContext = createContext(false);
